import { useEffect } from 'react';

/** Título da aba e do app instalado. `index.html` traz um neutro até a primeira tela decidir. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
